import React, { useState, useEffect } from 'react';
// import arrow from '../Icons/arrow.svg';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import Select from 'react-select';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const UpdatePriceHeads = () => {
  const { id: priceHeadId } = useParams(); 
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const AuthorizationToken = localStorage.getItem('token');
  const epicxTenantId = localStorage.getItem('epicxTenantId');
  const [isActivePriceHeads, setIsActivePriceHeads] = useState(false);
  const [selectedPriceCategories, setSelectedPriceCategories] = useState([]);
  const [priceHeadsName, setPriceHeadsName] = useState('');
  const [priceHeadsType, setPriceHeadsType] = useState('');
  const [priceHeadsValue, setPriceHeadsValue] = useState('');
  const [priority, setPriority] = useState('');
  const [effectiveDate, setEffectiveDate] = useState('');
  const [expirationDate, setExpirationDate] = useState('');
  const [priceHeadsDescription, setPriceHeadsDescription] = useState('');
  const [loading, setLoading] = useState(true);

  const categoriesOptions = [
    { value: 'category1', label: 'Category 1' },
    { value: 'category2', label: 'Category 2' },
    { value: 'category3', label: 'Category 3' },
  ];

  // Fetch data
  useEffect(() => {
    const fetchPriceHead = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/promoCode/api/priceHeads/${epicxTenantId}/${priceHeadId}`,
          {
            headers: {
                Authorization: `Bearer ${AuthorizationToken}`,
              },
            }
        );
        const data = response.data;
        setPriceHeadsName(data.priceHeadsName);
        setPriceHeadsType(data.priceHeadsType);
        setPriceHeadsValue(data.priceHeadsValue.toString());
        setPriority(data.priority.toString());
        setSelectedPriceCategories(
          data.applicableCategories.map((category) => ({
            value: category,
            label: category,
          }))
        );
        setEffectiveDate(data.effectiveDate.split('T')[0]);
        setExpirationDate(data.expirationDate.split('T')[0]);
        setIsActivePriceHeads(data.ActiveorDeactivatePriceHeads);
        setPriceHeadsDescription(data.priceHeadDescription);
      } catch (error) {
        toast.error('Error fetching price head details');
      } finally {
        setLoading(false);
      }
    };

    fetchPriceHead();
  }, [epicxTenantId, priceHeadId]);

  const handleUpdate = async () => {
    try {
      const updatedData = {
        priceHeadsName,
        priceHeadsType,
        priceHeadsValue: parseInt(priceHeadsValue, 10),
        priority: parseInt(priority, 10),
        applicableCategories: selectedPriceCategories.map((option) => option.value),
        effectiveDate,
        expirationDate,
        ActiveorDeactivatePriceHeads: isActivePriceHeads,
        priceHeadDescription: priceHeadsDescription,
      };

      await axios.put(
        `${BASE_URL}/promoCode/api/priceHeads/${epicxTenantId}/${priceHeadId}`,
        updatedData,
        {
          headers: {
              Authorization: `Bearer ${AuthorizationToken}`,
            },
          }
      );
      toast.success('Price head updated successfully');
    } catch (error) {
      toast.error('Error updating price head');
    }
  };
  if (loading) {
    return <div>Loading...</div>;
  }

  // Custom styles for react-select
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: '#f8f9fa',
      borderColor: '#ced4da',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#80bdff',
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  return (
    <>
      <Sidebar />
      <div style={{ height: '92vh', overflowY: 'auto', width: '100%' }}>
        <div className="container">
          <div>
            <h5 style={{ padding: '20px' }}>Price Heads</h5>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', paddingBottom: '20px' }}>
            <div className="card">
              <div className="card-header bg-light d-flex justify-content-between align-items-center">
                <h5>Price Heads Information</h5>
              </div>
              <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div className="row">
                  <div className="col">
                    <label htmlFor="priceHeadsName">Price Heads Name</label>
                    <span style={{ color: 'red' }}>*</span>
                    <input
                      type="text"
                      className="form-control bg-light"
                      id="priceHeadsName"
                      value={priceHeadsName}
                      onChange={(e) => setPriceHeadsName(e.target.value)}
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="priceHeadsType">Price Heads Type</label>
                    <span style={{ color: 'red' }}>*</span>
                    <select
                      className="form-control bg-light"
                      id="priceHeadsType"
                      value={priceHeadsType}
                      onChange={(e) => setPriceHeadsType(e.target.value)}
                    >
                      <option value="">Select Type</option>
                      <option value="type1">Type 1</option>
                      <option value="type2">Type 2</option>
                      <option value="type3">Type 3</option>
                    </select>
                  </div>
                  <div className="col">
                    <label htmlFor="priceHeadsValue">Price Heads Value</label>
                    <span style={{ color: 'red' }}>*</span>
                    <input
                      type="text"
                      className="form-control bg-light"
                      id="priceHeadsValue"
                      value={priceHeadsValue}
                      onChange={(e) => setPriceHeadsValue(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <label htmlFor="priority">Priority</label>
                    <span style={{ color: 'red' }}>*</span>
                    <input
                      type="text"
                      className="form-control bg-light"
                      id="priority"
                      value={priority}
                      onChange={(e) => setPriority(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="applicableCategories">Applicable Categories</label>
                    <span style={{ color: 'red' }}>*</span>
                    <Select
                      id="applicableCategories"
                      options={categoriesOptions}
                      isMulti
                      value={selectedPriceCategories}
                      onChange={setSelectedPriceCategories}
                      styles={customStyles}
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="effectiveDate">Effective Date</label>
                    <span style={{ color: 'red' }}>*</span>
                    <input
                      type="date"
                      className="form-control bg-light"
                      id="effectiveDate"
                      value={effectiveDate}
                      onChange={(e) => setEffectiveDate(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <label htmlFor="expirationDate">Expiration Date</label>
                    <span style={{ color: 'red' }}>*</span>
                    <input
                      type="date"
                      className="form-control bg-light"
                      id="expirationDate"
                      value={expirationDate}
                      onChange={(e) => setExpirationDate(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Active or Deactivate Price Heads</label>
                    <div className="form-check form-switch" style={{ marginLeft: '25px' }}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="priceHeadsToggle"
                        checked={isActivePriceHeads}
                        onChange={() => setIsActivePriceHeads(!isActivePriceHeads)}
                      />
                      <label className="form-check-label" htmlFor="priceHeadsToggle">
                        {isActivePriceHeads ? 'Active' : 'Deactivate'}
                      </label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <label htmlFor="priceHeadsDescription">Description</label>
                    <span style={{ color: 'red' }}>*</span>
                    <textarea
                      className="form-control bg-light"
                      id="priceHeadsDescription"
                      rows="2"
                      value={priceHeadsDescription}
                      onChange={(e) => setPriceHeadsDescription(e.target.value)}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row" style={{ backgroundColor: '#e5e5e5', padding: '10px' }}>
            <div className="col">
              <button className="btn" style={{ backgroundColor: 'white', color: 'black' }}>
                Cancel
              </button>
            </div>
            <div className="col text-right">
              <button
                className="btn"
                type="button"
                style={{ backgroundColor: '#1ea072', color: 'white', marginLeft: '76%' }}
                onClick={handleUpdate}
              >
                Update Price Heads
              </button>
            </div>
          </div>
        </div>
        <Footer />
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={true}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </>
  );
};

export default UpdatePriceHeads;
